import styled from "styled-components";

const HeaderContainer = styled.div``;

const Header = styled.div`
  font-weight: bold;
  padding: 10px 15px 6px 15px;
  font-size: 1.4rem;
  border-bottom: 1px solid #d9e1e2;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ChartTypeContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 10px 15px 0px 15px;
  gap: 5px;
  grid-template-rows: repeat(auto-fit, minmax(70px, 1fr));
  max-height: 100vh; //needs a max height to allow the row auto-fit to work
`;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function ChartTypeHeader({
  children,
  header = "",
  headerRight = null
}): JSX.Element {
  return (
    <HeaderContainer>
      <Header>
        <span>{header}</span>
        {headerRight && <div>{headerRight}</div>}
      </Header>
      <ChartTypeContainer>{children}</ChartTypeContainer>
    </HeaderContainer>
  );
}
